export const HISTORY_ACTIONS = [
    {
        label: 'Create',
        value: 'create'
    },
    {
        label: 'Update',
        value: 'update'
    },
    {
        label: 'Delete',
        value: 'delete'
    },
    {
        label: 'General',
        value: 'general'
    },
    {
        label: 'Activate',
        value: 'activate'
    },
    {
        label: 'Deactivate',
        value: 'deactivate'
    }
];